/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_PendingInputs */

const en_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pending`)
};

const he_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ממתין`)
};

/**
* | output |
* | --- |
* | "pending" |
*
* @param {Status_PendingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_pending = /** @type {((inputs?: Status_PendingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_PendingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_pending(inputs)
	return he_status_pending(inputs)
});